import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MsalProvider, useMsal, useIsAuthenticated } from '@azure/msal-react';
import { msalInstance, loginRequest } from './authConfig';
import { ChatPage } from './components/ChatPage';
import { HealthDashboard } from './components/HealthDashboard';
import { SyncStatus } from './components/SyncStatus';
import { LoginPage } from './components/LoginPage';
import { AdminDashboard } from './components/admin/AdminDashboard';
import './index.css';

function AppContent() {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  if (!isAuthenticated) {
    return <LoginPage onLogin={handleLogin} />;
  }

  return (
    <>
      {/* Skip-to-content link — visible only when focused. Keyboard users
          tab past the sidebar/nav by jumping straight to #main-content. */}
      <a
        href="#main-content"
        style={{
          position: 'absolute',
          left: '-9999px',
          top: 0,
          padding: '8px 16px',
          background: 'var(--doyle-blue)',
          color: '#fff',
          borderRadius: '0 0 4px 0',
          textDecoration: 'none',
          fontWeight: 600,
          zIndex: 10000,
        }}
        onFocus={(e) => {
          e.currentTarget.style.left = '0';
        }}
        onBlur={(e) => {
          e.currentTarget.style.left = '-9999px';
        }}
      >
        Skip to main content
      </a>
      <Routes>
        <Route path="/" element={<Navigate to="/chat" replace />} />
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/chat/:chatId" element={<ChatPage />} />
        <Route path="/health" element={<HealthDashboard />} />
        <Route path="/sync" element={<SyncStatus />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="*" element={<Navigate to="/chat" replace />} />
      </Routes>
    </>
  );
}

export function App() {
  const [msalInitialized, setMsalInitialized] = useState(false);

  useEffect(() => {
    // Initialize MSAL before rendering the provider
    const initMsal = async () => {
      try {
        await msalInstance.initialize();
        const result = await msalInstance.handleRedirectPromise();
        
        if (result?.account) {
          msalInstance.setActiveAccount(result.account);
        } else {
          const accounts = msalInstance.getAllAccounts();
          if (accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
          }
        }
        
        setMsalInitialized(true);
      } catch (error) {
        console.error('MSAL initialization error:', error);
        setMsalInitialized(true); // Still render, let user see error
      }
    };

    initMsal();
  }, []);

  if (!msalInitialized) {
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh',
        background: '#1a1a1a'
      }}>
        <div style={{
          border: '4px solid #333',
          borderTop: '4px solid #0078d4',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          animation: 'spin 1s linear infinite'
        }} />
      </div>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </MsalProvider>
  );
}